import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01">
            <h2>{{ 'performanceReview.Summary' | translate }}</h2>
        </div>
        <div class="quiz">
            <div class="question">
                <h3>{{ 'performanceReview.Summary of performance review' | translate }}</h3>
                <textarea
                    class="form-control print-hide"
                    ng-model="vm.form.model.summary"
                    ng-disabled="vm.review.isReadOnly"
                    ng-readOnly="vm.review.isReadOnly"
                ></textarea>
                <span class="print-only">{{vm.form.model.summary}}</span>
            </div>
            <div class="question">
                <h3>{{ 'performanceReview.Direct manager comment' | translate }}</h3>
                <textarea
                    class="form-control print-hide"
                    ng-model="vm.form.model.managerComment"
                    ng-disabled="vm.review.isReadOnly || !vm.review.isManager"
                    ng-readOnly="vm.review.isReadOnly || !vm.review.isManager"
                ></textarea>
                <span class="print-only">{{vm.form.model.managerComment}}</span>
            </div>
            <div class="question">
                <h3>{{ 'performanceReview.Employee comment' | translate }}</h3>
                <textarea
                    class="form-control print-hide"
                    ng-model="vm.form.model.employeeComment"
                    ng-disabled="vm.review.isReadOnly || vm.review.isManager"
                    ng-readOnly="vm.review.isReadOnly || vm.review.isManager"
                ></textarea>
                <span class="print-only">{{vm.form.model.employeeComment}}</span>
            </div>
        </div>
    `
})
export default class {
    constructor ($scope, ReviewResource, ReviewService, FormFactory, REVIEW_STATUS_ENUM) {
        this.$scope = $scope;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.FormFactory = FormFactory;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
        $scope.$on('review:save', () => this.save());
        $scope.$on('review:confirm', (event, finalConfirm) => this.confirm(finalConfirm));
    }

    $onInit () {
        if (this.review.isManageView) {
            this.form = this.FormFactory.create(
                this.review,
                model => this.ReviewResource.get(model.id).$promise
            );
            return;
        }
        const expand = this.ReviewService.getExpandString();
        this.form = this.FormFactory.create(
            this.review,
            model => this.ReviewResource.publicUpdate({ guid: model.guid, expand }, model).$promise
        );
    }

    /**
     * @param finalConfirm true if user presses final confirm button after both manager and employee have confirmed
     */
    confirm (finalConfirm = false) {
        if (finalConfirm) {
            this.form.model.status = this.REVIEW_STATUS_ENUM.KEYS.CONFIRMED;
        }
        else if (this.form.model.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_EMPLOYEE && !this.form.model.isManager) {
            this.form.model.status = this.REVIEW_STATUS_ENUM.KEYS.FILL_MANAGER;
        }
        else if (this.form.model.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_MANAGER && this.form.model.isManager) {
            this.form.model.status = this.REVIEW_STATUS_ENUM.KEYS.CONFIRM_EMPLOYEE;
        }
        this.save(finalConfirm);
    }

    save (finalConfirm = false) {
        this.form.save()
            .then(() => this.$scope.$emit('review:confirm:success', finalConfirm))
            .catch(() => this.$scope.$emit('review:save:error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/summary/index.js